"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var DistributionService = /** @class */ (function () {
    function DistributionService($http) {
        this.$http = $http;
    }
    DistributionService.prototype.hasSpfRecord = function (domain) {
        var url = '/distribution-service/v1/utils/spf';
        return this.$http.get(url, {
            params: {
                domain: domain
            }
            // @ts-ignore
        }).then(this.handleHasSpfRecordResponse);
    };
    DistributionService.prototype.handleHasSpfRecordResponse = function (response) {
        return lodash_1.default.get(response, 'data.hasQualtricsSpf', false);
    };
    DistributionService.$inject = ['$http'];
    return DistributionService;
}());
(function (angularModule) {
    angularModule.service('pr.distributionService', DistributionService);
})(angular.module('qualtrics.pr'));
